var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddCourseAi = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0C6.30125 0 6.54545 0.244208 6.54545 0.545455C6.54545 3.25667 8.74333 5.45455 11.4545 5.45455C11.7558 5.45455 12 5.69875 12 6C12 6.30125 11.7558 6.54545 11.4545 6.54545C8.74333 6.54545 6.54545 8.74333 6.54545 11.4545C6.54545 11.7558 6.30125 12 6 12C5.69875 12 5.45455 11.7558 5.45455 11.4545C5.45455 8.74333 3.25667 6.54545 0.545455 6.54545C0.244208 6.54545 0 6.30125 0 6C0 5.69875 0.244208 5.45455 0.545455 5.45455C3.25667 5.45455 5.45455 3.25667 5.45455 0.545455C5.45455 0.244208 5.69875 0 6 0Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddCourseAi);
export default ForwardRef;